export default __webpack_public_path__ + "static/media/fixture1_vertical_bar.f6038c88.png";